import * as angular from 'angular';
import { IWidget } from '../widgets';
import { widgetResized, widgetDragged } from '../common';
import { DefaultGridsterOptions, IGridsterOptions } from '../models';

export class GridsterOptions {

    private _gridsterOptions: IGridsterOptions = angular.copy(DefaultGridsterOptions);

    // keep it non static to prevent break
    options(): IGridsterOptions {
        return angular.copy(this._gridsterOptions);
    }

    defaultWidgetConfigure($rootScope: angular.IRootScopeService, item: (value?) => IWidget) {

        const gridsterOptions = this.options();

        gridsterOptions.rowHeight = 20;
        gridsterOptions.maxRows = 300;
        gridsterOptions.minRows = 36;
        gridsterOptions.sparse = true;
        this.resizeGridster(gridsterOptions);

        let startCol: number;
        let startRow: number;
        gridsterOptions.draggable.start = (event, uiWidget, $element: IWidget) => {
            if (!item()) {
                item($element);
            }
            startCol = $element.col;
            startRow = $element.row;
        };

        gridsterOptions.draggable.stop = (event, uiWidget, $element) => {
            if (startCol !== $element.col || startRow !== $element.row) {
                $rootScope.$broadcast(widgetDragged, { col: $element.col, row: $element.row, guid: $element.guid });
                startCol = null;
                startRow = null;
            }
        };

        let startSizeX: number;
        let startSizeY: number;
        gridsterOptions.resizable.start = (event, uiWidget, $element: IWidget) => {
            this.resizeGridster(gridsterOptions);
            if (!item()) {
                item($element);
            }
            startSizeX = $element.sizeX;
            startSizeY = $element.sizeY;
        };

        gridsterOptions.resizable.stop = (event, uiWidget, $element) => {
            if (startSizeX !== $element.sizeX || startSizeY !== $element.sizeY) {
                $rootScope.$broadcast(widgetResized,
                    { sizeX: $element.sizeX, sizeY: $element.sizeY, guid: $element.guid  });
                startSizeX = null;
                startSizeY = null;
            }
        };

        return gridsterOptions;
    }

    private resizeGridster(gridsterOptions) {
        gridsterOptions.margins = (window.innerWidth < 1500) ? [8, 8] : [14, 14];
    }
}